import { setPriceFilter } from '@/helpers/search/getBudget'
import { MAX_DEFAULT_BUDGET, MIN_DEFAULT_BUDGET } from '@/helpers/priceHelper'
import type { StateSearchBudgetFilters } from '@@/types/search/types'

export const useSearchBudgetFilters = () => {
  const stateSearchBudgetFilters = useState<StateSearchBudgetFilters>(
    'state-search-budget-filter',
  )

  const minBudget = computed(() => stateSearchBudgetFilters.value.minBudget)
  const maxBudget = computed(() => stateSearchBudgetFilters.value.maxBudget)

  const price = computed(() => {
    return setPriceFilter({
      minBudget: stateSearchBudgetFilters.value.minBudget,
      maxBudget: stateSearchBudgetFilters.value.maxBudget,
    })
  })

  const hasBudget = computed(
    () =>
      minBudget.value !== MIN_DEFAULT_BUDGET ||
      maxBudget.value !== MAX_DEFAULT_BUDGET,
  )

  const clearBudgetFilters = () => {
    stateSearchBudgetFilters.value.minBudget = MIN_DEFAULT_BUDGET
    stateSearchBudgetFilters.value.maxBudget = MAX_DEFAULT_BUDGET
  }

  const setBudgetFilters = (minBudget: string, maxBudget: string) => {
    stateSearchBudgetFilters.value.minBudget = minBudget
    stateSearchBudgetFilters.value.maxBudget = maxBudget
  }

  return {
    clearBudgetFilters,
    hasBudget,
    maxBudget,
    minBudget,
    price,
    setBudgetFilters,
  }
}
